module.exports = __webpack_public_path__ + "static/media/home3_.62ebb8b3.svg";